'use client';

import { useSyncExternalStore } from 'react';
import {
  getHeaderLocationServerSnapshot,
  getHeaderLocationSnapshot,
  subscribeHeaderLocation,
} from '@/lib/utils/headerLocationStorage';

export function useStoredHeaderLocation(brandCode: string) {
  return useSyncExternalStore(
    (callback) => subscribeHeaderLocation(brandCode, callback),
    () => getHeaderLocationSnapshot(brandCode),
    getHeaderLocationServerSnapshot,
  );
}
